"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  '/': {
    title: 'Main page',
    view: 'Home',
    "public": true,
    locales: {
      az: '/az',
      en: '/',
      ru: '/ru'
    }
  },
  '/az': {
    ref: '/',
    lang: 'az',
    title: 'Baş səhifə'
  },
  '/ru': {
    ref: '/',
    lang: 'ru',
    title: 'Главная страница'
  },
  '/notfound': {
    title: '404',
    view: 'NotFound',
    "public": true,
    locales: {
      az: '/az/notfound',
      en: '/en/notfound',
      ru: '/ru/notfound'
    }
  },
  '/az/notfound': {
    ref: '/notfound',
    lang: 'az',
    title: 'Səhifə tapılmadı'
  },
  '/en/notfound': {
    ref: '/notfound',
    lang: 'en',
    title: 'Page not found'
  },
  '/ru/notfound': {
    ref: '/notfound',
    lang: 'ru',
    title: 'Страница не найдена'
  },
  '/error': {
    title: 'Error page',
    view: 'Error',
    layout: 'Error',
    "public": true,
    locales: {}
  },
  '/az/error': {
    ref: '/error',
    lang: 'az',
    title: 'Səhv səhifə'
  },
  '/en/error': {
    ref: '/error',
    lang: 'en',
    title: 'Error page'
  },
  '/ru/error': {
    ref: '/error',
    lang: 'ru',
    title: 'Страница ошибки'
  },
  '/soon': {
    title: 'Coming Soon',
    view: 'Soon',
    layout: 'Soon',
    "public": true,
    locales: {}
  },
  '/az/soon': {
    ref: '/soon',
    lang: 'az',
    title: 'Tezliklə'
  },
  '/en/soon': {
    ref: '/soon',
    lang: 'en',
    title: 'Coming Soon'
  },
  '/ru/soon': {
    ref: '/soon',
    lang: 'ru',
    title: 'Скоро'
  }
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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